import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { useState } from 'react';

import AgentHorizontalOpen from '@/images/share/AgentHorizontalOpen.png';
import AgentWidgetAvatar from '@/images/share/AgentWidgetAvatar.png';
import DesktopWidgetBackground from '@/images/share/DesktopWidgetBackground.png';
import FrameDesktop from '@/images/share/FrameDesktop.png';
import FrameMobile from '@/images/share/FrameMobile.png';
import MobileWidgetBackground from '@/images/share/MobileWidgetBackground.png';
import MobileWidgetOpen from '@/images/share/MobileWidgetOpen.png';
import { DesktopIcon, MobileIcon } from './ShareModalIcons';
import { EmbedMode, EmbedPosition } from './types';

const MediumOption = styled.div`
    cursor: pointer;
`;

const ToggleMedium = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 32px;
`;

const PreviewContainer = styled.div`
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

const PreviewWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

function MobileWidgetOpenPreview({ setOpen }: { setOpen: (value: boolean) => void }) {
    return (
        <Box
            style={{ cursor: 'pointer' }}
            onClick={() => setOpen(false)}
            src={MobileWidgetOpen}
            component="img"
            maxWidth="100%"
            height={472}
        />
    );
}

function FloatingWidget({
    mobile,
    open,
    setOpen,
    position,
}: {
    mobile: boolean;
    open: boolean;
    setOpen: (value: boolean) => void;
    position: EmbedPosition;
}) {
    return (
        <Box position="relative">
            {open ? (
                <OpenWidgetButton position={position} setOpen={setOpen} />
            ) : (
                <WidgetAvatarButton position={position} setOpen={setOpen} />
            )}
            <WidgetBackground mobile={mobile} />
        </Box>
    );
}

function OpenWidgetButton({ position, setOpen }: { position: EmbedPosition; setOpen: (value: boolean) => void }) {
    return (
        <Box zIndex={1} position="absolute" bottom={34} right={position === 'right' ? 34 : 'auto'} left={position === 'left' ? 34 : 'auto'}>
            <Box
                component="img"
                style={{ cursor: 'pointer', width: '420px', height: '236px' }}
                onClick={() => setOpen(false)}
                src={AgentHorizontalOpen}
            />
        </Box>
    );
}

function WidgetAvatarButton({ position, setOpen }: { position: EmbedPosition; setOpen: (value: boolean) => void }) {
    return (
        <Box
            component="img"
            src={AgentWidgetAvatar}
            position="absolute"
            bottom="34px"
            width="85px"
            style={{ cursor: 'pointer' }}
            left={position === 'left' ? '29px' : 'auto'}
            right={position === 'right' ? '29px' : 'auto'}
            onClick={() => setOpen(true)}
        />
    );
}

function WidgetBackground({ mobile }: { mobile: boolean }) {
    return <Box component="img" maxWidth="100%" height="472px" src={!mobile ? DesktopWidgetBackground : MobileWidgetBackground} />;
}

export function PreviewModeToggle({ mobile, setMobile }: { mobile: boolean; setMobile: (value: boolean) => void }) {
    return (
        <ToggleMedium>
            <MediumOption onClick={() => setMobile(false)}>
                <DesktopIcon active={!mobile} />
            </MediumOption>
            <MediumOption onClick={() => setMobile(true)}>
                <MobileIcon active={mobile} />
            </MediumOption>
        </ToggleMedium>
    );
}

interface PreviewProps {
    position: EmbedPosition;
    mode: EmbedMode;
}

export default function Preview({ mode, position }: PreviewProps) {
    const [mobile, setMobile] = useState(false);
    const [open, setOpen] = useState(false);

    const floating = !mobile || !open;

    return (
        <PreviewContainer>
            <PreviewWrapper>
                {mode === 'fabio' && !floating && <MobileWidgetOpenPreview setOpen={setOpen} />}
                {mode === 'fabio' && floating && <FloatingWidget mobile={mobile} open={open} setOpen={setOpen} position={position} />}
                {mode === 'full' && <Box component="img" src={mobile ? FrameMobile : FrameDesktop} maxWidth="100%" maxHeight="60vh" />}
            </PreviewWrapper>
            <PreviewModeToggle mobile={mobile} setMobile={setMobile} />
        </PreviewContainer>
    );
}
